import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import { ColorLabels } from "@/components/editor/utils/colors";

const StyledTitleContainer = styled.div`
  text-align: center;
  margin-bottom: ${rem(40)};
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
`;

export const StyledList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

interface BenefitsProps {
  children?: React.ReactNode;
}

export default function Benefits(props: BenefitsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper maxWidth="1248px">
          <StyledTitleContainer>
            <Element
              id="benefit-section-title"
              is={Text}
              element="h2"
              text="Look forward to..."
              pattern="headingTwo"
            />
          </StyledTitleContainer>
          <StyledList>{props.children}</StyledList>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Benefits.craft = {
  isCanvas: true,
  custom: {
    displayName: "Benefits",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
